import React from 'react';
import * as yup from 'yup';
import { searchRouteOfAdministration } from '../../../Async/MedicationsSummaryAsync';
import { AutosaveForm, AutosaveOperations } from '../../../Components/AutosaveForm/AutosaveForm';
import { AutosaveStyledSelectAsync } from '../../../Components/AutosaveForm/AutosaveStyledSelectAsync';
import { AutosaveTextField } from '../../../Components/AutosaveForm/AutosaveTextField';
import { referenceToKey, referenceToString } from '../../../Shared/SharedModels';
import { freeTextInstructionContractToForm } from './useDosageInstructionState';
import styles from './FreeTextInstructionsForm.module.css';
var freeTextInstructionSchema = yup.object();
var strictTextInstructionSchema = function (routeRequired) {
    return yup.object({
        type: yup.mixed(),
        instructions: yup.string().trim().required('Instructions are required'),
        routeOfAdministration: yup
            .object()
            .nullable()
            .test({
            name: 'Route of administration is required',
            message: 'Route of administration is required',
            test: function (value) {
                if (routeRequired)
                    return !!value;
                return true;
            }
        })
    });
};
export function freeTextInstructionFormToContract(form) {
    return {
        instructions: form.instructions,
        routeOfAdministration: form.routeOfAdministration
    };
}
export var FreeTextInstructionsForm = function (props) {
    var _a;
    return (React.createElement(AutosaveForm, { initialContractValue: props.instruction, autosaveOperation: AutosaveOperations.Put, mapFormToAPIContract: freeTextInstructionFormToContract, mapGetContractToForm: function (contract) { return freeTextInstructionContractToForm(contract); }, serverCallback: props.postApi, onSubmitted: function (form) {
            props.onUpdate(form);
        }, validationSchema: props.required
            ? strictTextInstructionSchema((_a = props.requiredRouteOfAdministration) !== null && _a !== void 0 ? _a : false)
            : freeTextInstructionSchema, render: function () {
            return (React.createElement("div", null,
                React.createElement(AutosaveTextField, { readOnly: props.readOnly, field: 'instructions', label: props.label, multiline: true, maxLength: 250, required: props.required }),
                React.createElement("div", { className: styles.routeOfAdministration },
                    React.createElement(AutosaveStyledSelectAsync, { readOnly: props.readOnly, field: 'routeOfAdministration', label: 'Route of administration', required: props.requiredRouteOfAdministration, maxResults: 5, itemToString: referenceToString, itemToMenuKey: referenceToKey, testId: 'selection-input-route-of-administration', fetch: searchRouteOfAdministration, isClearable: true, hideWarningEmptyHelperText: true }))));
        } }));
};
